module.exports = __webpack_public_path__ + "static/img/home_gg_1.ea55ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_gg_1.png
// module id = cv+s
// module chunks = 1